import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58393214"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "closed-obligations-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wrap-col-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "wrap-col-header__title" }, "Obligaciones cerradas")
], -1))
const _hoisted_3 = {
  key: 0,
  class: "center invisible md:visible"
}
const _hoisted_4 = {
  key: 2,
  class: "text-xs md:text-sm font-semibold text-primary flex center bg-white shadow-md rounded-md p-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_ClosedObligationsItem = _resolveComponent("ClosedObligationsItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_Loader, {
            showLoader: _ctx.isLoading,
            styles: 'relative'
          }, null, 8, ["showLoader"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.existClosedObligations)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.closedObligations, (closedObligation, index) => {
          return (_openBlock(), _createBlock(_component_ClosedObligationsItem, {
            key: index,
            obligation: closedObligation,
            onDownloadDocument: _ctx.downloadDocument
          }, null, 8, ["obligation", "onDownloadDocument"]))
        }), 128))
      : _createCommentVNode("", true),
    (!_ctx.existClosedObligations && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Actualmente no cuenta con paz y salvos disponibles para su descarga "))
      : _createCommentVNode("", true)
  ]))
}